/**
 * Current Players Count Component
 * Shows the number of players currently playing the game
 */

import React from 'react';
import Image from '../../../../../../shared/components/Image';
import styles from './GameComponents.module.css';

interface CurrentPlayersCountProps {
  currentPlayers?: number;
  src?: string;
}

const CurrentPlayersCount: React.FC<CurrentPlayersCountProps> = ({ 
  currentPlayers, 
  src = '/ui/currentPlayers' 
}) => {
  if (!currentPlayers || currentPlayers === 0) {
    return null;
  }
  
  return (
    <div className={`${styles.playersContainer} current_players_container`}>
      <Image src={src} alt="" manualAffix='.svg' className="current_players_icon" />
      <span className={`${styles.playersText} current_players_text`}>{currentPlayers}</span>
    </div>
  );
};

export default CurrentPlayersCount;